import { init } from "echarts";
import {
    USER_INFO,
    RESET_USER_INFO,
    INIT_USER_INFO,
    USER_COLLECT_SCHOOL,
    REMOVE_COLLECT_SCHOOL,
    SCHOOL_FINDER_DATA,
    INIT_SCHOOL__DATA,
    SAVE_TOTAL_SACORE,
    REMOVE_COLLECT_SCHOOL_ALL
  } from "./mutation-types";
export default{
saveToken(state,{token}){
    state.token=token;
},
initIsShowMsg(state){
    state.isShowMsg=false;
},
setIsLoginOut(state,{isLoginOut}){
    state.isLoginOut=isLoginOut;
},
initIsLoginOut(state){
    state.isLoginOut=false;
},
setIsShowMsg(state,{isShowMsg2}){
    state.isShowMsg=isShowMsg2;
},
saveUserInfo(state,{userInfo}){
    state.userInfo=userInfo;
    state.isUpdateToken=true;
},
initIsUpdateToken(state){
    state.isUpdateToken=false;
},
saveIsUpdateToken(state,{isUpdateToken}){
    state.isUpdateToken=isUpdateToken;
},
initUserInfoTimer(state){
    state.userInfoTimer=null;
},
saveUserInfoTimer(state,{userInfoTimer}){
    state.userInfoTimer=userInfoTimer;
},
saveUserName(state,{userName}){
    state.userName=userName;
},
saveUserPwd(state,{userPwd}){
    state.userPwd=userPwd;
},
getSchoolFind(state,{schoolFindData}){
    state.schoolFindData=schoolFindData;
    state.isUpdateToken=false;
},
getRecommend(state,{recommendData}){
    state.recommendData=recommendData;
    state.isUpdateToken=false;
},
initUserName(state){
    state.userName='';
},
initUserPwd(state){
    state.userPwd='';
},
initSchoolFind(state){
    state.schoolFindData={};
},
initRecommend(state){
    state.recommendData={};
},
initUserInfo(state){
    state.userInfo={};
},
initToken(state){
    state.token="";
},
initUserType(state){
    state.userType=0;
},
initIsMd5(){
    state.isMd5=false;
},
saveIsMd5(state,{isMd5}){
    state.isMd5=isMd5;
},
saveYfLoadElement(state,{yfLoad}){
    state.yfLoadElement=yfLoad;
},
initYfLoadElement(state){
    state.yfLoadElement=false;
},
saveCollectSchool(state,{collectSchool,pc}){
    state.collectInfo.collectSchool=collectSchool;
    state.collectInfo.pc=pc;
},
initCollectSchool(state){
    state.collectInfo={collectSchool:[],pc:null};
},
saveLrzyfaList(state,{lrzyfaList,pc}){
    state.lrzyfaInfo.lrzyfaList=lrzyfaList;
    state.lrzyfaInfo.pc=pc;
},
initLrzyfaList(state){
    state.lrzyfaInfo={lrzyfaList:[],pc:null};
},
saveCompareSchool(state,{compareSchool}){
    state.compareSchool=compareSchool;
},
initCompareSchool(state){
    state.compareSchool=[];
},
initSchool(state){
    state.schoolData=[];
    console.log("清除了艺术生的院校数据");
},
initYshUserInfo(state,{userInfo}){
    state.userInfo=userInfo
},
resetUserInfo(state) {
    state.userInfo = {};
    state.schoolData = {};
},
setUserType(state,{type}){
    state.userType=type;
},
userCollectSchool(state, { collectSchool }) {
    console.log(collectSchool);
    state.collectSchool = collectSchool;
},
initYsCollectInfo(state){
    state.ysCollectInfo.pc=0;
    state.ysCollectInfo.pageNum=null;
},
setYsCollectPc(state,{pc}){
    state.ysCollectInfo.pc=pc;
},
setYsCollectPageNum(state,{pageNum}){
    state.ysCollectInfo.pageNum=pageNum;
},
[REMOVE_COLLECT_SCHOOL](state, { schools }) {
      state.collectSchool.records = state.collectSchool.records.filter(o => {
        return o.gb !== schools.collegeid;
      });
      state.collectSchool.bkZyzRecords = state.collectSchool.bkZyzRecords.filter(o => {
        return o.gb !== schools.collegeid;
      });
      state.collectSchool.zkZyzRecords = state.collectSchool.zkZyzRecords.filter(o => {
        return o.gb !== schools.collegeid;
      });
      if(state.schoolData.data) {
        let activeSchool = state.schoolData.data.records;
        activeSchool.map(item => {
          if (item.gb === schools.collegeid) {
            item.collect = false;
          }
        });
        let activeSchool2 = state.schoolData.data.bkZyzRecords;
        activeSchool2.map(item => {
          if (item.gb === schools.collegeid) {
            item.collect = false;
          }
        });
        let activeSchool3 = state.schoolData.data.zkZyzRecords;
        activeSchool3.map(item => {
          if (item.gb === schools.collegeid) {
            item.collect = false;
          }
        });
      }
}, 
// 删除全部收藏院校
[REMOVE_COLLECT_SCHOOL_ALL](state) {
  state.collectSchool = [];
  state.schoolData = [];
},
[SAVE_TOTAL_SACORE](state, { totalScore }) {
  state.totalScore = totalScore;
},
  // 艺术生院校查询数据
[SCHOOL_FINDER_DATA](state, { schoolData }) {
    state.schoolData = schoolData;
},
};
